import React, { useEffect } from "react";
import { X } from "lucide-react";
import { useModal } from "../../context/ModalContext";

const Modal = ({ isOpen, onClose, title, children, size = "md",modalType }) => {
  const { incrementModalCount, decrementModalCount } = useModal();

  // Auto-sync modal state with global context
  useEffect(() => {
    if (isOpen) {
      incrementModalCount();
      return () => {
        decrementModalCount();
      };
    }
  }, [isOpen, incrementModalCount, decrementModalCount]);

  useEffect(() => {
    const handleEscapeKey = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
      document.body.style.overflow = "unset";
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const sizeClasses = {
    sm: "max-w-md",
    md: "max-w-lg",
    lg: "max-w-2xl",
    xl: "max-w-4xl",
  };

  return (
    <div className="fixed inset-0 z-[100] overflow-y-auto">
      {/* Backdrop — stronger dim + blur so the panel reads as a floating pop-up */}
      <div
        className="fixed inset-0 backdrop-blur-md bg-black/45 transition-opacity animate-in fade-in duration-200"
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Modal */}
      <div className="relative flex min-h-full items-center justify-center p-4 sm:p-6 pointer-events-none">
        <div
          className={`pointer-events-auto relative w-full ${sizeClasses[size]} transform overflow-hidden rounded-2xl bg-bg-primary shadow-2xl ring-1 ring-black/10 transition-all animate-in fade-in zoom-in-95 duration-200`}
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          {/* Header */}
          <div className="flex items-center justify-between px-6 py-2 border-b border-border-primary">
          <div className="flex items-center gap-2">
            {modalType&&modalType}
            <h3 className="text-lg font-semibold text-text-primary">{title}</h3>
            </div>
            <button
              onClick={onClose}
              className="rounded-md p-2 text-text-tertiary hover:text-text-secondary hover:bg-bg-hover transition-colors"
              >
              <X className="w-5 h-5" />
            </button>
          </div>

          {/* Content */}
          <div className="px-6 py-4">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
